<template>
    <div class="u-padding-narrow">
        <div class="u-margin-bottom-narrow"></div>

        <div class="layout layout--center | u-full-height">
            <div class="layout__item u-4/5-desk">
                <services-overview
                    :showCustomerColumn="true"
                    :showAddDnsButton="validated"
                    :tableData="servicesTableData"
                    :isLoading="loading"
                    @dnsAdded="dnsAdded"
                    @startLoading="startLoading"
                    @finishLoading="finishLoading"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { servicesMixin, ServicesOverview, servicesPageMixin } from 'relapp-technical-management';
import { EventBus } from 'relapp-event';

export default {
    components: {
        ServicesOverview
    },
    metaInfo: {
        title: trans('page.services.title')
    },
    mixins: [servicesMixin, servicesPageMixin],

    /**
     * Initialize list.
     */
    mounted() {
        this.getServices();
    },
    computed: {
        ...mapGetters({
            servicesTableData: 'services/servicesTableData',
            user: 'user/user',
            currentCustomer: 'user/currentCustomer'
        }),
        /**
         * Check if the user is validated
         *
         * @return {boolean}
         */
        validated() {
            return this.user && this.currentCustomer && this.currentCustomer.isValidated > 0 && this.canOrder;
        }
    },
    methods: {
        /**
         * Event listener for when a DNS service was successfully added.
         */
        dnsAdded() {
            this.getServices();
            this.$router.push({ name: 'services' });

            EventBus.$emit('notification', {
                type: 'success',
                message: trans('services.confirmation.dns.message')
            });
        }
    }
};
</script>
